// import React from 'react';

const GET_CUSTOMER_INFO_START = 'GET_CUSTOMER_INFO_START';
const GET_CUSTOMER_INFO_SUCCESS = 'GET_CUSTOMER_INFO_SUCCESS';
const GET_CUSTOMER_INFO_FAILURE = 'GET_CUSTOMER_INFO_FAILURE';
const REGISTER_CUSTOMER_INFO_START = 'REGISTER_CUSTOMER_INFO_START';
const REGISTER_CUSTOMER_INFO_SUCCESS = 'REGISTER_CUSTOMER_INFO_SUCCESS';
const REGISTER_CUSTOMER_INFO_FAILURE = 'REGISTER_CUSTOMER_INFO_FAILURE';

const GET_GROOMER_INFO_START = 'GET_GROOMER_INFO_START';
const GET_GROOMER_INFO_SUCCESS = 'GET_GROOMER_INFO_SUCCESS';
const GET_GROOMER_INFO_FAILURE = 'GET_GROOMER_INFO_FAILURE';
const REGISTER_GROOMER_INFO_START = 'REGISTER_GROOMER_INFO_START';
const REGISTER_GROOMER_INFO_SUCCESS = 'REGISTER_GROOMER_INFO_SUCCESS';
const REGISTER_GROOMER_INFO_FAILURE = 'REGISTER_GROOMER_INFO_FAILURE';

const GET_USER_INFO_START = 'GET_USER_INFO_START';
const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
const GET_USER_INFO_FAILURE = 'GET_USER_INFO_FAILURE';

const UPDATE_CUSTOMER_START = 'UPDATE_CUSTOMER_START';
const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
const UPDATE_CUSTOMER_FAILURE = 'UPDATE_CUSTOMER_FAILURE';
const UPDATE_GROOMER_START = 'UPDATE_GROOMER_START';
const UPDATE_GROOMER_SUCCESS = 'UPDATE_GROOMER_SUCCESS';
const UPDATE_GROOMER_FAILURE = 'UPDATE_GROOMER_FAILURE';

export {
  GET_CUSTOMER_INFO_START,
  GET_CUSTOMER_INFO_SUCCESS,
  GET_CUSTOMER_INFO_FAILURE,
  REGISTER_CUSTOMER_INFO_START,
  REGISTER_CUSTOMER_INFO_SUCCESS,
  REGISTER_CUSTOMER_INFO_FAILURE,
  GET_GROOMER_INFO_START,
  GET_GROOMER_INFO_SUCCESS,
  GET_GROOMER_INFO_FAILURE,
  REGISTER_GROOMER_INFO_START,
  REGISTER_GROOMER_INFO_SUCCESS,
  REGISTER_GROOMER_INFO_FAILURE,
  GET_USER_INFO_START,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO_FAILURE,
  UPDATE_CUSTOMER_START,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAILURE,
  UPDATE_GROOMER_START,
  UPDATE_GROOMER_SUCCESS,
  UPDATE_GROOMER_FAILURE,
};
